import type { CliE2eeRuntime } from '../../lib/e2ee/index.js';
import type { PreviewEnvironmentLogTails } from './types.js';

export function buildFirehoseSnapshotMessage(params: {
  environmentId: string;
  viewerId: string;
  tails: PreviewEnvironmentLogTails;
  e2ee?: CliE2eeRuntime;
}): Record<string, unknown> {
  const payload = {
    type: 'log_snapshot' as const,
    environmentId: params.environmentId,
    viewerId: params.viewerId,
    stdoutTail: params.tails.stdout,
    stderrTail: params.tails.stderr,
  };
  return params.e2ee ? params.e2ee.encryptFields(payload, ['stdoutTail', 'stderrTail']) : payload;
}

export function buildFirehoseLogChunkMessage(params: {
  environmentId: string;
  stream: 'stdout' | 'stderr';
  text: string;
  e2ee?: CliE2eeRuntime;
}): Record<string, unknown> {
  const payload = {
    type: 'log_chunk',
    environmentId: params.environmentId,
    stream: params.stream,
    text: params.text,
  };
  return params.e2ee ? params.e2ee.encryptFields(payload, ['text']) : payload;
}
